/**
 * See "Ocius Payment Application Solution Integration Specification v2.5 - 11th September 2019.pdf" page 56.
 *
 * @type {{string: {id: number, message: string, parameters?:string[]}}}
 */
const Actions = {
    CONTINUE_TRANSACTION: {
        id: 2,
        message: 'Continue Transaction',
    },
    CONFIRM_SIGNATURE: {
        id: 3,
        message: 'Confirm Signature',
    },
    REJECT_SIGNATURE: {
        id: 4,
        message: 'Reject Signature',
    },
    REPRINT_RECEIPT: {
        id: 5,
        message: 'Reprint Receipt',
    },
    VOICE_REFERRAL_AUTHORISED: {
        id: 7,
        message: 'Voice Referral Authorised',
        parameters: ['AUTHCODE'],
    },
    VOICE_REFERRAL_REJECTED: {
        id: 8,
        message: 'Voice Referral Rejected',
    },
    CANCEL_TRANSACTION: {
        id: 12,
        message: 'Cancel Transaction',
    },
    CHANGE_CARD: {
        id: 19,
        message: 'Change Card',
    },
    CONFIRM_AUTH_CODE: {
        id: 20,
        message: 'Confirm Auth Code',
    },
    REJECT_AUTH_CODE: {
        id: 21,
        message: 'Reject Auth Code',
    },
    RETRY_DEVICE: {
        id: 24,
        message: 'Retry Device',
    },
    CASHBACK_REQUIRED: {
        id: 29,
        message: 'Cashback Required',
        parameters: ['CASHBACK'],
    },
    CASHBACK_NOT_REQUIRED: {
        id: 30,
        message: 'Cashback Not Required',
    },
    REPLACE_ACCOUNT: {
        id: 34,
        message: 'Replace Account',
        parameters: ['MGRPIN'],
    },
    CANCEL_REPLACE_ACCOUNT: {
        id: 35,
        message: 'Cancel Replace Account',
    },
    ACCOUNT_ON_FILE_REGISTRATION_REQUIRED: {
        id: 38,
        message: 'Account On File Registration Required',
    },
    ACCOUNT_ON_FILE_REGISTRATION_NOT_REQUIRED: {
        id: 39,
        message: 'Account On File Registration Not Required',
    },
    ATTEMPT_TO_RECONNECT: {
        id: 40,
        message: 'Attempt To Reconnect',
    },
    GO_OFFLINE: {
        id: 41,
        message: 'Go Offline',
    },
    NO_TRANSACTION_VALUE_UPDATE_REQUIRED: {
        id: 55,
        message: 'No Transaction Value Update Required',
    },
    TRANSACTION_VALUE_UPDATE_REQUIRED: {
        id: 56,
        message: 'Transaction Value Update Required',
        parameters: ['TXNVALUE'],
    },
    MERCHANT_REFERENCE_ENTERED: {
        id: 59,
        message: 'Merchant Reference Entered',
        parameters: ['REF'],
    },
    ACCEPT_CUSTOMER_RECEIPT: {
        id: 73,
        message: 'Accept Customer Receipt',
    },
    REJECT_CUSTOMER_RECEIPT: {
        id: 75,
        message: 'Reject Customer Receipt',
    },
};

module.exports = Actions;
